import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { mfetch, MemberApiError } from '../api';
import Icon from '../design/Icon';
import { inrExact } from '../design/atoms';

/* "₹X due · Pay now" — shown only when the member owes this gym something and
   the gym collects online. Paying opens the same hosted pay page a WhatsApp
   link does, for everything owed at once. Renders nothing otherwise. */

interface Dues { amount: number; overdue: boolean; canPayOnline: boolean; sales: { id: string; items: string[] }[] }

export default function DuesCard({ token, gymId }: { token: string; gymId: string }) {
  const [dues, setDues] = useState<Dues | null>(null);
  const [opening, setOpening] = useState(false);

  useEffect(() => {
    let live = true;
    setDues(null);
    mfetch(token, '/member/dues', { params: { gymId } })
      .then(r => { if (live) setDues(r.data); })
      .catch(() => { /* optional card — never block the page */ });
    return () => { live = false; };
  }, [token, gymId]);

  if (!dues || dues.amount <= 0 || !dues.canPayOnline) return null;

  const pay = async () => {
    setOpening(true);
    try {
      const r = await mfetch(token, '/member/dues/pay', { method: 'POST', body: { gymId } });
      window.location.assign(r.data.url);
    } catch (e) {
      toast.error(e instanceof MemberApiError ? e.message : 'Could not start the payment');
      setOpening(false);
    }
  };

  const items = dues.sales.flatMap(s => s.items);
  return (
    <div className={`card ${dues.overdue ? '' : 'tint'}`} style={{ padding: 16 }}>
      <div className="col" style={{ gap: 12 }}>
        <div className="between" style={{ alignItems: 'flex-start', gap: 12 }}>
          <div className="col" style={{ gap: 2, minWidth: 0 }}>
            <span className="lbl" style={dues.overdue ? { color: 'var(--clay)' } : undefined}>{dues.overdue ? 'Overdue' : 'Amount due'}</span>
            <div className="num" style={{ fontSize: 26, fontWeight: 800 }}>{inrExact(dues.amount)}</div>
            {items.length > 0 && <div className="tiny trunc">{items.length === 1 ? items[0] : `${items[0]} + ${items.length - 1} more`}</div>}
          </div>
          <div className="li"><Icon n="card" s={18} /></div>
        </div>
        <button className="btn gold block" disabled={opening} onClick={pay}>
          {opening ? 'Opening secure payment…' : <>Pay now <Icon n="right" s={17} /></>}
        </button>
      </div>
    </div>
  );
}
